<template lang="pug">
	.cardBody
		h2(v-if="cardBodyTitle") {{ cardBodyTitle }}
		h3(v-if="cardBodySubTitle") {{ cardBodySubTitle }}
		div(v-if="cardBodyText" v-html="cardBodyText")
</template>
<script>
export default {
	name: "CardBody",
	props: {
		cardBodyTitle: {
			type: [String, Boolean]
		},
		cardBodySubTitle: {
			type: [String, Boolean]
		},
		cardBodyText: {
			type: [String, Boolean]
		}
	}
}
</script>
<style lang="sass" scoped></style>